import './sentry'
import React from 'react'
import { fr as dateFnsFr } from 'date-fns/locale/fr'
import { enGB as dateFnsEn } from 'date-fns/locale/en-GB'
import ReactDOM from 'react-dom/client'
import { RouterProvider } from 'react-router-dom'
import { Provider } from 'react-redux'
import { ThemeProvider, createTheme, responsiveFontSizes } from '@mui/material/styles'
import { LocalizationProvider } from '@mui/x-date-pickers-pro'
import { AdapterDateFns } from '@mui/x-date-pickers-pro/AdapterDateFnsV3'
import GlobalStyles from '@mui/material/GlobalStyles'
import { frFR as coreFrFR } from '@mui/material/locale'
import { frFR as dateFrFR } from '@mui/x-date-pickers-pro/locales'
import { I18nextProvider } from 'react-i18next'
import { ToastContainer } from 'react-toastify'
import { LicenseInfo } from '@mui/x-license'
import * as Sentry from '@sentry/react'

import 'react-toastify/dist/ReactToastify.css'

import { themeOptions, globalStyles } from './app/theme'
import { router } from './app/router'
import { store } from './app/store'
import i18n from './app/i18n'
import reportWebVitals from './reportWebVitals'

LicenseInfo.setLicenseKey(
  '48e68ed81986963fa0883963922b59d3Tz05NzA2NixFPTE3NTY0Njk4MDgwMDAsUz1wcmVtaXVtLExNPXN1YnNjcmlwdGlvbixQVj1pbml0aWFsLEtWPTI='
)

const defaultTheme = responsiveFontSizes(createTheme(themeOptions, dateFrFR, coreFrFR))

const root = ReactDOM.createRoot(document.getElementById('root')!, {
  // React 19+ Only
  // Callback called when an error is thrown and not caught by an ErrorBoundary.
  // onUncaughtError: Sentry.reactErrorHandler((error, errorInfo) => {
  //   console.warn('Uncaught error', error, errorInfo.componentStack);
  // }),
  // Callback called when React catches an error in an ErrorBoundary.
  // onCaughtError: Sentry.reactErrorHandler(),
  // Callback called when React automatically recovers from errors.
  onRecoverableError: Sentry.reactErrorHandler(),
})
root.render(
  <React.StrictMode>
    <Sentry.ErrorBoundary>
      <Provider store={store}>
        <I18nextProvider i18n={i18n}>
          <LocalizationProvider
            dateAdapter={AdapterDateFns}
            adapterLocale={i18n.resolvedLanguage === 'fr' ? dateFnsFr : dateFnsEn}
          >
            <ThemeProvider theme={defaultTheme}>
              <GlobalStyles styles={globalStyles} />
              <RouterProvider router={router(store)} />
              <ToastContainer />
            </ThemeProvider>
          </LocalizationProvider>
        </I18nextProvider>
      </Provider>
    </Sentry.ErrorBoundary>
  </React.StrictMode>
)

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()
